var _ = require('underscore/underscore');
var BasePopup = require('front/components/BasePopup/BasePopup');

var template = require('./GuildProductionDesignInitiativePopup.jinja');
require('./GuildProductionDesignInitiativePopup.less');

var ProductionDesignInitiativeApplication = require('front/components/ProductionDesignInitiativeApplication/ProductionDesignInitiativeApplication');
var ProductionDesignInitiativeApplicationCancel = require('front/components/ProductionDesignInitiativeApplicationCancel/ProductionDesignInitiativeApplicationCancel');
var ProductionDesignInitiativeApplicationAgreement = require('front/components/ProductionDesignInitiativeApplicationAgreement/ProductionDesignInitiativeApplicationAgreement');
var ProductionDesignInitiativeApplicationSuccess = require('front/components/ProductionDesignInitiativeApplicationSuccess/ProductionDesignInitiativeApplicationSuccess');

var ProductionDesignInitiativeReview = require('front/components/ProductionDesignInitiativeReview/ProductionDesignInitiativeReview');
var ProductionDesignInitiativeReviewRuntimeTemplate = require('front/components/ProductionDesignInitiativeReview/ProductionDesignInitiativeReviewRuntime.jinja');

module.exports = BasePopup.extend({

    template: template,

    events: _.extend({
        'click .GuildProductionDesignInitiativePopup-buttonsCancel': 'onCancelClick',
        'click .GuildProductionDesignInitiativePopup-buttonsBack': 'onBackClick',
        'click .GuildProductionDesignInitiativePopup-buttonsReview': 'onReviewClick',
        'click .GuildProductionDesignInitiativePopup-buttonsSubmit': 'onSubmitClick'
    }, BasePopup.prototype.baseEvents),


    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'ProductionDesignInitiativeApplication': {selector: '.ProductionDesignInitiativeApplication', viewConstructor: ProductionDesignInitiativeApplication},
        'ProductionDesignInitiativeApplicationCancel': {selector: '.ProductionDesignInitiativeApplicationCancel', viewConstructor: ProductionDesignInitiativeApplicationCancel},
        'ProductionDesignInitiativeApplicationAgreement': {selector: '.ProductionDesignInitiativeApplicationAgreement', viewConstructor: ProductionDesignInitiativeApplicationAgreement},
        'ProductionDesignInitiativeApplicationSuccess': {selector: '.ProductionDesignInitiativeApplicationSuccess', viewConstructor: ProductionDesignInitiativeApplicationSuccess}
    },


    apiUrl: function () {
        return Urls['front:api:guild_production_design_initiative-popup']('json');
    },

    renderData: function () {
        return {
            popup: this.data || {}
        };
    },

    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'showAgreement');

        BasePopup.prototype.initialize.call(this, options);
    },


    viewsRegistration: function () {
        BasePopup.prototype.viewsRegistration.call(this);

        this.application = this.getView('ProductionDesignInitiativeApplication');
        this.cancel = this.getView('ProductionDesignInitiativeApplicationCancel');
        this.agreement = this.getView('ProductionDesignInitiativeApplicationAgreement');
        this.success = this.getView('ProductionDesignInitiativeApplicationSuccess');

        this.application.on('show-agreement', this.showAgreement);
    },


    deactivate: function (params) {
        this.review && this.review.deactivate();

        this.application && this.application.off('show-agreement', this.showAgreement);

        delete this.review;

        return BasePopup.prototype.deactivate.call(this, params);
    },


    showAgreement: function () {
        this.agreement.show({
            $parent: this.$el
        });
    },


    onCancelClick: function () {
        this.close();
    },


    close: function () {
        if (this.application && this.application.hasChanges()) {
            this.cancel && this.cancel.show({
                cb: function (confirmed) {
                    if (confirmed) {
                        BasePopup.prototype.close.call(this);
                    }
                }.bind(this)
            });
        } else {
            BasePopup.prototype.close.call(this);
        }
    },


    onBackClick: function () {
        this.$el.find('.GuildProductionDesignInitiativePopup').attr('data-state', 'application');
    },


    onReviewClick: function () {
        if (!this.application) return;

        if (!this.application.checkRequired()) return;

        var data = this.application.getFormData();

        this.review && this.review.deactivate();

        var $template = $(ProductionDesignInitiativeReviewRuntimeTemplate.render({
            data: data
        }));

        this.$('.GuildProductionDesignInitiativePopup-review').html($template);

        this.review = new ProductionDesignInitiativeReview({
            el: $template[0]
        });

        this.$el.find('.GuildProductionDesignInitiativePopup').attr('data-state', 'review');

        app.animateWindowScroll(0);
    },


    onSubmitClick: function () {
        if (!this.application) return;

        if (!this.application.checkRequired()) return;

        var data = this.application.getFormData();
        var $button = this.$('.GuildProductionDesignInitiativePopup-buttonsSubmit').addClass('Button--loading');

        this.submitXhr && this.submitXhr.abort();

        this.submitXhr = $.ajax({
            url: Urls['front:api:guild_production_design_initiative-popup']('json'),
            method: 'POST',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify(data),
            success: function (responseData) {
                $button.removeClass('Button--loading');

                this.success && this.success.show({
                    cb: function (confirmed) {
                        BasePopup.prototype.close.call(this);
                    }.bind(this)
                });
            }.bind(this),
            error: function (e, tp) {
                $button.removeClass('Button--loading');

                if (tp != 'abort') {
                    alert('Error ' + e.status + ': ' + e.statusText);
                }

                console.log('error', arguments);
            }
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/GuildProductionDesignInitiativePopup/GuildProductionDesignInitiativePopup.js
// module id = 268
// module chunks = 0